const React = require('react');
const withState = require('../../../../../../../../utils/withState');
const Ripple = require("../../../../../../../dumb/Ripple");

const TabsBtn = ({id, name, active, onClick}) => {
  return (
    <Ripple
      id={id}
      className={`
       w146 h40 layoutRow jcC aiC ttU 
       w73:first-child fxUnset:first-child jcFS:first-child 
       w73:last-child fxUnset:last-child jcFE:last-child 
       fw7.active      
      ` + (active ? ' active' : '')}
      onClick={() => onClick && onClick(id)}
    >
      {name}
    </Ripple>
  )
}

const timePeriods = [
  {
    id: 'day',
    name: 'day'
  },
  {
    id: 'week',
    name: 'week'
  },
  {
    id: 'month',
    name: 'month'
  },
  {
    id: 'sixMonths',
    name: '6 months'
  },
  {
    id: 'year',
    name: 'year'
  },
  {
    id: 'all',
    name: 'all'
  }
]

module.exports = withState((setState, self, onMount) => {
  const defaultTimePeriod = timePeriods[3].id;

  const getBorderPosition = (activeTimePeriod) => {
    const activeIndex = timePeriods.findIndex((el) => el.id === activeTimePeriod);

    const activeIndexIsFirst = activeIndex == 0;
    const activeIndexIsLast = activeIndex == timePeriods.length - 1;

    const width = (activeIndexIsFirst || activeIndexIsLast)
      ? 73
      : 146;
    const activeBtn = document.getElementById(activeTimePeriod);

    if (!activeBtn) return;

    const activeBtnLeft = activeBtn.offsetLeft;

    const left = activeIndexIsFirst
      ? activeBtnLeft - 22
      : activeIndexIsLast
        ? activeBtnLeft + width / 2 - 16
        : activeBtnLeft;

    return {left: left, width};
  }

  onMount(() => {
    setTimeout(() => {
      const timePeriodEmitter = self.props.timePeriodEmitter;
      const activeTimePeriod = (timePeriodEmitter && timePeriodEmitter.getValue()) || defaultTimePeriod;
      const pos = getBorderPosition(activeTimePeriod)
      setState(pos);
      setTimeout(() => {
        setState({loaded: true});
      })
    })
  });

  const handleTimePeriodSelection = (id) => {
    const pos = getBorderPosition(id);
    setState(pos);

    const timePeriodEmitter = self.props.timePeriodEmitter;
    timePeriodEmitter && timePeriodEmitter.emit(id);
  }

  return (state, props) => {

    const timePeriodEmitter = props.timePeriodEmitter;
    const activeTimePeriod = timePeriodEmitter && timePeriodEmitter.getValue() || defaultTimePeriod;

    const {width = 140, left = 0, loaded} = state;

    return (
      <div id="chartTabs" className="rlv pl30">
        <div className="layoutRow jcSB">
          {timePeriods.map(({id, name}) => (
            <TabsBtn
              key={id}
              id={id}
              name={name}
              active={activeTimePeriod === id}
              onClick={(id) => handleTimePeriodSelection(id)}
            />
          ))}
        </div>
        <span
          className={
            'dN h2 abs sb0 bg0 dB.loaded tn_all_0.25s_ease_0s.loaded'
            + (loaded ? ' loaded' : '')
          }
          style={{
            width,
            left
          }}
        />
      </div>
    )
  };
})